var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactWhatsappIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 24.7535,
    cy: 24.7537,
    r: 24.2535,
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_244_32039)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9579 17.0083C30.8529 14.9008 28.0535 13.7397 25.0711 13.7385C18.9256 13.7385 13.9241 18.7399 13.9216 24.887C13.9208 26.852 14.4342 28.7702 15.4099 30.461L13.8281 36.2385L19.7386 34.688C21.3672 35.5764 23.2007 36.0446 25.0666 36.0451H25.0713C31.216 36.0451 36.2181 31.0433 36.2205 24.8959C36.2217 21.9167 35.063 19.1156 32.9579 17.0083ZM25.0711 34.1622H25.0673C23.4045 34.1615 21.7737 33.7146 20.3507 32.8705L20.0125 32.6696L16.5051 33.5897L17.4413 30.17L17.2208 29.8194C16.2932 28.344 15.8033 26.6386 15.8042 24.8877C15.8061 19.7783 19.9633 15.6215 25.0748 15.6215C27.55 15.6223 29.8768 16.5875 31.6264 18.3391C33.376 20.0908 34.3389 22.419 34.3381 24.8952C34.3359 30.005 30.1789 34.1622 25.0711 34.1622ZM30.1542 27.2217C29.8757 27.0822 28.506 26.4084 28.2506 26.3153C27.9954 26.2224 27.8095 26.1761 27.6239 26.4549C27.4381 26.7336 26.9043 27.3612 26.7417 27.547C26.5791 27.733 26.4168 27.7563 26.1382 27.6168C25.8595 27.4774 24.9619 27.1831 23.8978 26.234C23.0697 25.4953 22.5106 24.5831 22.348 24.3043C22.1857 24.0252 22.3466 23.889 22.4702 23.7357C22.7718 23.3613 23.0738 22.9686 23.1666 22.7828C23.2596 22.5969 23.2131 22.4341 23.1433 22.2948C23.0738 22.1554 22.5167 20.7841 22.2846 20.2262C22.0583 19.6832 21.8288 19.7565 21.6577 19.748C21.4953 19.7399 21.3095 19.7382 21.1237 19.7382C20.9381 19.7382 20.6362 19.8079 20.3808 20.0869C20.1255 20.3658 19.4059 21.0397 19.4059 22.4109C19.4059 23.7822 20.4041 25.1068 20.5434 25.2928C20.6826 25.4787 22.5079 28.2926 25.3024 29.4992C25.9671 29.7865 26.4859 29.9577 26.8906 30.0861C27.558 30.2982 28.1651 30.2682 28.6452 30.1965C29.1806 30.1165 30.2933 29.5225 30.5257 28.8719C30.7578 28.2211 30.7578 27.6634 30.688 27.547C30.6185 27.4309 30.4327 27.3612 30.1542 27.2217Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_244_32039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(13 13.0002)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactWhatsappIcon);
export default __webpack_public_path__ + "static/media/contactWhatsappIcon.d13afc6a9c9de7158750d66f174932e9.svg";
export { ForwardRef as ReactComponent };